<template>
  <!-- 用户注册协议 -->
  <Modal
    v-model="modal"
    title="DigQuant 用户注册协议"
    ok-text="同意"
    cancel-text="拒绝"
    :styles="{ top: '60px' }"
    @on-ok="$emit('if-agree', true)"
    @on-cancel="$emit('if-agree', false)"
  >
    <div id="agreement_modal" class="scroll-bar-gray">
      <p>
        「 点宽学园DigQuant - 金融科技教育平台」(以下简称“本平台”)
        是由深圳点宽网络科技有限公司（以下简称DigQuant）开发。
        当您使用本平台时，即表示您已阅读、了解并同意接受本协议书约定的所有内容。
        DigQuant有权于任何时间修改或变更本协议书的内容，建议您随时注意相应修改或变更。
        如果您于DigQuant修改或变更协议书后仍使用本平台，视为您已阅读、了解并同意接受该等修改或变更。
      </p>
      <p>
        如果您不同意本协议书约定的内容，或者您所属的国家或地域排除本协议书约定的内容全部或一部分时，您应立即停止使用本平台。
      </p>
      <p>
        1、为了能使用本平台及提供的一系列服务，您需履行下列义务：
        依本平台注册表之提示提供您本人正确、最新及完整的资料，维持并更新您个人资料，确保其为正确、最新及完整的；
        若您提供任何错误或不实的资料，DigQuant
        有权暂停或终止您的帐号，并拒绝您使用本平台之全部或一部分；
        您需认知通过本平台执行交易时存在可能发生的系统风险，使用者需自行承担可能的系统风险和交易损失。
      </p>
      <p>
        2、关于您的账号注册以及其他特定资料依
        DigQuant“隐私权政策”受到保护与规范。
      </p>
      <p>
        3、完成本平台的登记注册之后，您有责任维持帐号及密码的机密安全。
        当您的「平台帐号与密码」遭到盗用或有其他任何安全问题发生时，您应立即通知
        DigQuant，协助处理；
        当您的「交易帐号与密码」遭到盗用或有其他任何安全问题发生时，您应立即通知您的期货公司或证券公司，协助处理。
        每次连线完毕，请您确认结束您的帐号使用。
      </p>
      <p>
        4、本平台有时可能会出现中断或故障等现象，或许将造成您使用上的不便、资料丧失、错误、或其他形式上的损失等。
        您在使用本平台时必须自行采取防护措施。 DigQuant
        对于您因使用（或无法使用）本平台而造成的损害，不负任何赔偿责任。
      </p>
      <p>
        5、用户在使用本平台各项服务特别是在购买系列产品和服务前，
        已经仔细评估自身资产实力、风险承受能力以及对投资策略的理解、应用能力，
        所有直接或间接使用本平台产品与服务时，用于真实交易的用户需要具有专业的量化投资及策略编写知识。
        DigQuant 不承担任何客户因自身模型或者策略产生的资金损失及相关责任。
      </p>
      <p>
        6、当您购买本平台的产品与服务时，您已经充分了解产品与服务类型，并充分了解购买须知，本平台不接受任何理由的退换申请。
        您已充分知晓并愿意承担在本平台上的资金交易行为（如充值、支付等）及所牵涉到的第三方资金账号的潜在风险，
        本平台不承担客户因充值、支付等产生的任何损失及相关责任。
      </p>
      <p>
        7、凡通过本平台网站与其他网站的链接，而获得其所提供的网上资料及内容，用户应该自行辨别及判断，
        并应当由该等网站对其提供内容承担相应责任，DigQuant 对此不承担任何责任。
        本平台提供超级链接至其它网站，并不视为同意、推荐、认可、保证或推介任何第三方或在其网站所提供的服务、产品，
        亦不可视为与该等第三方及网站有任何形式的合作。
      </p>
      <p>
        8、任何在本平台出现的信息包括但不限于评论、预测、图表、指标、理论、直接的或暗示的指示均只作为参考信息，
        用户须对任何自主决定的行为负责。
      </p>
      <p>
        9、本平台随时会与其他公司、厂商等第三人（“交易服务商”、“内容提供者”）合作，
        由其提供包括新闻、讯息、电子报等不同内容供本平台刊登，
        刊登时均将注明内容提供者。
      </p>
      <p>
        10、厂商或个人可能透过本平台或经由本平台连结到其他网站提供商品买卖、服务或其他交易行为。
        您若因此与该等厂商或个人进行交易，各买卖或其他合约均仅存在您与各厂商或个人双方之间。
        您应要求各厂商或个人，就其商品、服务或其他交易标的物之品质、内容、运送、保证事项与瑕疵担保责任等，事先详细解释与说明。
        您因前述买卖、服务或其他交易行为所产生之争执，应向各厂商或个人寻求救济或解决之道。
        DigQuant
        声明绝不介入您与厂商或个人间的任何买卖、服务或其他交易行为，对于您所获得的商品、服务或其他交易标的物亦不负任何担保责任。
      </p>
      <p>
        11、若您无合法权利得以使用、修改、重制、公开播送、改作、散布、发行、公开发表某资料，并将前述权利转授权第三人，
        请勿擅自将该资料上载、传送、输入或提供予
        DigQuant。任何资料一经您上载、传送、输入或提供予 DigQuant 时，
        视为您已允许 DigQuant
        可以基于公益或私益之目的，无条件使用、修改、重制、公开播送、改作、散布、发行、公开发表该等资料，
        并得以将前述权利转授权他人，您对此绝无异议。 您并应保证 DigQuant
        使用、修改、重制、公开播送、改作、散布、发行、公开发表、转授权该等资料，
        不致侵害任何第三人之智慧财产权， 否则应对 DigQuant
        负损害赔偿责任（包括但不限于诉讼费用及律师费用等），并承担由此对第三方的赔偿责任。
      </p>
      <p>
        12、DigQuant
        所载商标、服务标志及其他任何数据的所有版权、专利权、知识产权及其它产权均属深圳数字动能信息技术有限公司所有，
        DigQuant 所载资料受版权保护。 未经 DigQuant
        事前以书面同意，不可将此等材料的任何部分修改、翻版、储存于检索系统、传送、复制、分发或以任何其它方式作商业或公共用途。
      </p>
      <p>
        DigQuant
        认为，一切登录本平台的用户或浏览者在进入本平台主页及各层页面时已经仔细阅读本协议书内容以及其他协议声明的所有内容并完全同意。
      </p>
    </div>
  </Modal>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      modal: this.value
    };
  },
  mounted(){
  },
  watch: {
    value(newVal) {
      this.modal = newVal;
    },
    modal(newVal) {
      this.$emit("input", newVal);
    }
  }
};
</script>

<style lang="less">
#agreement_modal {
  height: 400px;
  overflow: auto;
  p {
    font-size: 12px;
    line-height: 16px;
    color: #666;
    margin-top: 5px;
    &:nth-child(1) {
      color: #333;
      margin-top: 0px;
      font-size: 14px;
    }
    &:nth-child(2) {
      color: red;
      margin: 10px 0px;
    }
    &:last-child {
      margin-top: 10px;
      color: red;
    }
  }
}
</style>
